import { render } from "./PromotionView.vue?vue&type=template&id=a41d1d8c&scoped=true"
import script from "./PromotionView.vue?vue&type=script&lang=js"
export * from "./PromotionView.vue?vue&type=script&lang=js"

import "./PromotionView.vue?vue&type=style&index=0&id=a41d1d8c&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a41d1d8c"]])

export default __exports__